var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"generate-from-doc__wrapper",on:{"click":function($event){return _vm.importFileToGetQuiz()}}},[_c('aha-icon',{staticClass:"mr-1",attrs:{"name":"document-dark"}}),_c('span',[_vm._v(_vm._s(_vm.$i18nPresenter.t('Generate from doc')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }